import { FileText } from 'lucide-react'
import { CoverChip } from '@/components/catalog/CourseStatusChip'
import { ACCESS_META } from '@/features/instructions/lib/accessMeta'
import type { AccessType } from '@/features/instructions/types'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/** Статус доступа поверх обложки инструкции — тем же чипом, что у карточек курсов.
 *  Закрытая статья на карточке — «Черновик», как у курсов. */
export const AccessBadge = ({ accessType }: { accessType: AccessType }) => {
  const m = useMessages(messages)
  const meta = ACCESS_META[accessType] ?? ACCESS_META.private
  const { icon, label } = accessType === 'private' ? { icon: FileText, label: m.draft } : meta
  return (
    <div className="absolute left-3 top-3 z-20">
      <CoverChip icon={icon} label={label} />
    </div>
  )
}
